import { Texto, Vertical } from '@gravitate-js/excalibrr'
import { Button } from 'antd'
import { Link } from 'react-router-dom'

type NumberListCellRendererProps = {
  link?: string
  values: Array<string>
  getOrderNumber?: (value: string) => string | null | undefined
}

export function NumberListCellRenderer({ link, values, getOrderNumber }: NumberListCellRendererProps) {
  return values?.filter(Boolean).length ? (
    <Vertical>
      {values.map((v) =>
        link ? (
          <Link
            key={v}
            to={`/order_movements_page/report?${new URLSearchParams({ order_number: String(getOrderNumber ? getOrderNumber(v) : v) })}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            <Button
              color='blue'
              variant='text'
              className='p-0'
              type='link'
              style={{ textDecoration: 'underline', height: '100%' }}
              size='small'
            >
              {v}
            </Button>
          </Link>
        ) : (
          <Texto key={v}>{v}</Texto>
        )
      )}
    </Vertical>
  ) : (
    <Texto appearance='light'>N/A</Texto>
  )
}
